import { styled } from '@mui/material';
import { Button } from '@silverstein-properties/inspirelabs-ui';

export const StyledButton = styled(Button)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightLight,
  textDecoration: 'underline',
}));
